
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/serviceCenters",
      function () {
        return require("private-next-pages/serviceCenters.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/serviceCenters"])
      });
    }
  